import React from 'react';
import { convertCO2GramsToBestUnit } from '../../../utils/unitHelper';
import { CircularProgress } from 'material-ui';
import Typography from '@material-ui/core/Typography';

export class AvoidedCO2Text extends React.Component {
  render() {
    const { classes, t, avoidedGrams, loading, user } = this.props;

    if (loading) {
      return <CircularProgress size={10} className={classes.buttonProgress} />;
    }

    let [formattedValue, unit] = convertCO2GramsToBestUnit(
      avoidedGrams,
      t,
      user
    );

    return (
      <Typography variant="h5" gutterBottom style={{ color: '#F87733' }}>
        {' '}
        {formattedValue} <span style={{ fontSize: '0.75rem' }}>{unit}</span>
      </Typography>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EquivalentToCards/AvoidedCO2/AvoidedCO2Text.js